export const birthOfYear = (state = "", action) => {
    switch (action.type) {
        case "birthOfYear_add": return action.payload; 
        case "birthOfYear_remove": return "";
        default: return state;
    }
}

export const patientId = (state = "", action) => {
    switch (action.type) {
        case "patientId_add": return action.payload; 
        case "patientId_remove": return "";
        default: return state;
    }
}


export const loadPatientDetails = (state =false, action) => {
    // console.log("loadPatientDetails_add", action.payload)
    switch (action.type) {
        case "loadPatientDetails_add": return action.payload; 
        default: return state;
    }
}


export const isNewPatient = (state =true, action) => {
    switch (action.type) {
        case "isNewPatient": return action.payload; 
        default: return state;
    }
}


